import React from "react";
import PropTypes from "prop-types";
import { AElement, CtaButton } from "../../Elements";

import { MiniCtaWrapper, MiniCta, Header, Description } from "./styles";

const MiniCTA = (props) => {
	const {
		header,
		description,
		backgroundColor,
		borderColor,
		cta,
		externalDependency,
		context,
	} = props;

	return (
		<MiniCtaWrapper>
			<MiniCta backgroundColor={backgroundColor} borderColor={borderColor}>
				<Header>{header}</Header>
				<Description
					dangerouslySetInnerHTML={{
						__html: description,
					}}
				/>
				{cta ? (
					<CtaButton
						cta={cta}
						Link={externalDependency.Link}
						className="ctaButton"
						pathName={context.fullSlug}
					/>
				) : null}
			</MiniCta>
		</MiniCtaWrapper>
	);
};

MiniCTA.propTypes = {
	header: PropTypes.string.isRequired,
	description: PropTypes.string,
	backgroundColor: PropTypes.string,
	borderColor: PropTypes.string,
	cta: PropTypes.shape({
		link: PropTypes.shape({
			type: PropTypes.oneOf(["hash", "external", "internal"]),
			value: PropTypes.string,
		}),
		color: PropTypes.string,
		type: PropTypes.oneOf(["solid", "outline"]),
		text: PropTypes.string,
	}),
	externalDependency: PropTypes.shape({
		Link: PropTypes.func,
	}),
	context: PropTypes.shape({
		fullSlug: PropTypes.string.isRequired,
	}).isRequired,
};

MiniCTA.defaultProps = {
	header: "",
	description: "",
	backgroundColor: "",
	borderColor: "",
	cta: null,
	externalDependency: {
		Link: AElement,
	},
	context: { fullSlug: "" },
};

export default MiniCTA;
